import React, { useState }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useStripe } from '@stripe/react-stripe-js';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Alert from '@material-ui/lab/Alert';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    section: {
        marginBottom: theme.spacing(3)
    },
}));

export default function Step3(props) {

    const { setLoading, refreshClub, stripeClub } = props;
    const stripe = useStripe();

    const [ values, setValues ] = useState({
        country: 'US',
        currency: 'usd',
        account_holder_name: stripeClub.stripe_representative_account.first_name + ' ' + stripeClub.stripe_representative_account.last_name,
        account_holder_type: (stripeClub.stripe_account.business_type == 'individual') ? 'individual' : "company",
        routing_number: "",
        account_number: ""
    })

    const [ tokenError, setTokenError ] = useState(false);
    const [ errors, setErrors ] = useState({})

    const classes = useStyles();
    const api = useApi();

    // Setters -------------------------------------------------

    const handleChange = name => e => {

        const target = e.target;
        const value = (target.type === 'checkbox' ? target.checked : target.value);

        if (isError(name)) delete errors[name];

        setValues({ ...values, [name]: value });
    };

    // Posters -------------------------------------------------

    const postBank = () => {

        setLoading(true);
        setTokenError(false);

        stripe.createToken('bank_account', values)
            .then((result) => {
                if (result.error) {
                    setLoading(false);
                    setTokenError(result.error.message)
                } else {
                    api.post('/admin/accounting/stripe/bank/create', {token: result.token})
                        .then(res => refreshClub())
                        .catch(error => {
                            setLoading(false)

                            if (error?.response?.data?.errors) {
                                setErrors(error.response.data.errors)
                            }
                        });
                }
            });
    }

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    }

    return (
        <form>
            <Grid container justify="space-between" align="center" className={classes.section}>
                <Grid item>
                    <Typography variant="h6" component="h2">
                        <Typography variant="inherit" component="span" color="primary">
                            Step 3:&nbsp;
                        </Typography>
                        <Typography variant="inherit" component="span">
                            Connect Your Bank
                        </Typography>
                    </Typography>
                </Grid>
                <Grid item>

                </Grid>
            </Grid>
            <Typography variant="subtitle1" color="textSecondary" className={classes.section}>
                Let's connect to your bank so you can start managing payouts as your members and guests begin to pay their invoices online. Please double check all fields before submitting.
            </Typography>
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={12}>
                    <Typography variant="subtitle2">Bank Account Information:</Typography>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="input-payment-onboarding-account-type"
                        select
                        label="Select Account Type"
                        value={values.account_holder_type}
                        onChange={handleChange('account_holder_type')}
                        error={isError('account_holder_type')}
                        helperText={getErrorMessage('account_holder_type')}
                        variant="outlined"
                        fullWidth
                        >
                        <MenuItem value="individual">
                            Individual
                        </MenuItem>
                        <MenuItem value="company">
                            Company
                        </MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                        The type of entity that holds the account.
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="input-payment-onboarding-account-name"
                        label="Account Holder Name"
                        value={values.account_holder_name}
                        onChange={handleChange('account_holder_name')}
                        fullWidth
                        error={isError('account_holder_name')}
                        helperText={getErrorMessage('account_holder_name')}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                        The name of the person or business that owns the bank account.
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="input-payment-onboarding-routing-number"
                        label="Routing Number"
                        value={values.routing_number}
                        onChange={handleChange('routing_number')}
                        fullWidth
                        error={isError('routing_number')}
                        helperText={getErrorMessage('routing_number')}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                        This should be the ACH (Not Wire) Routing Number associated with the Bank Account.
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="input-payment-onboarding-account-number"
                        label="Account Number"
                        value={values.account_number}
                        onChange={handleChange('account_number')}
                        fullWidth
                        error={isError('account_number')}
                        helperText={getErrorMessage('account_number')}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                        This should be the Account Number associated with the Bank Account. We only support checking accounts at this time.
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    {tokenError &&
                        <Alert variant="filled" severity="error">{tokenError}</Alert>
                    }
                </Grid>
                <Grid item xs={6} align="right">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={postBank}
                        >
                        Connect Bank
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
